export default {
  titulo: { label: "Asignar Permisos a Perfiles" }
  , privilegio: { th: "Privilegio" }
  , errors: {
    BD2004: { text: "Ocurrió un error al asignar permisos a perfiles" }
    , WS2004: { text: "Ocurrió un error al asignar permisos a perfiles" }
    , JS2004: { text: "Ocurrió un error al asignar permisos a perfiles" }
    , CR2004: { text: "Ocurrió un error al asignar permisos a perfiles" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/seguridad/privilegiosPerfiles.js